import { render } from "./AdvisorJobResultCard.vue?vue&type=template&id=2f8f010a&scoped=true"
import script from "./AdvisorJobResultCard.vue?vue&type=script&lang=js"
export * from "./AdvisorJobResultCard.vue?vue&type=script&lang=js"

import "./AdvisorJobResultCard.vue?vue&type=style&index=0&id=2f8f010a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8f010a"]])

export default __exports__